// extracted by mini-css-extract-plugin
module.exports = {"default":"Button_default__Lryhv"};